<template>
  <lottie
    :options="defaultOptions"
    :width="350"
    style="margin:0px;"
    :height="350"
  />
</template>
<script>
import Lottie from "vue-lottie";
import * as animationData from "@/assets/animations/invoice_materials.js";
export default {
  components: {
    Lottie
  },
  data() {
    return {
      defaultOptions: { animationData: animationData.default, loop: true },
      animationSpeed: 1.5
    };
  }
};
</script>
